<div class="lp-on-click-canvas-component" style="width: 100%; height: 100%"></div>
